<div class="search-box">
    <div class="search-box__header">
        <button mat-icon-button (click)="close()">
            <mat-icon [svgIcon]="eSvgIcons.CLOSE_THIN"></mat-icon>
        </button>
    </div>
    <div class="search-box__content">
        <div class="search-box__content__top">
            <p>Search</p>
            <button (click)="close()">Clear</button>
        </div>
        <mat-form-field subscriptSizing="dynamic">
            <input
                    matInput
                    type="text"
                    placeholder="Search accommodations"
                    [formControl]="searchControl"
                    [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete">
                @for (option of filteredHotels | async; track $index) {
                    <mat-option
                            [value]="option.name"
                            (onSelectionChange)="selectHotel(option.id)">
                        {{ option.name }}
                    </mat-option>
                }
            </mat-autocomplete>
            @if (!searchControl.value) {
                <mat-icon
                        class="icon-suffix icon-suffix--search"
                        [svgIcon]="eSvgIcons.SEARCH"
                ></mat-icon>
            } @else {
                <mat-icon
                        class="icon-suffix"
                        [svgIcon]="eSvgIcons.CLEAR"
                        (click)="clearSearch($event)"
                ></mat-icon>
            }
        </mat-form-field>
        <button mat-ripple class="search-box__btn" (click)="submit()" [disabled]="isSearchEnabled">
            Search
        </button>
        <div class="search-box__perks">
            <a (click)="setGoogleAnalytic()" href="https://www.booking.com/index.html?aid=7947415" target="_blank">
                <img src="https://res.cloudinary.com/djxk74uhg/image/fetch/f_auto/https://cdn.routeperfect.com/app/images/hotels/banner/booking-banner-m.png?_a=ATFGlAA0"
                     width="349"
                     height="331"
                     alt="booking banner"
                />
            </a>
        </div>
    </div>
    <div class="search-box__footer">
        <p>© RoutePerfect 2014-2024</p>
    </div>
</div>
